import { render } from "./App.vue?vue&type=template&id=aa98c3fc&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=aa98c3fc&lang=scss"

import exportComponent from "/var/www/dashboard_viomba_com/25/public/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__